import { proxy } from 'valtio'

export const windowSizeState = proxy({
  currentWidth: window.innerWidth,
  currentHeight: window.innerHeight,
  get ipadMini() {
    return this.currentWidth <= 1024 && this.currentHeight > 1000
  },
  get mobileMode() {
    return this.currentWidth <= 920
  },
  get phoneMode() {
    return this.currentWidth <= 550
  },
  get padMode() {
    return this.currentWidth <= 1400
  },
  get isMobileRotate() {
    return this.currentWidth < 768
  },

  get vw() {
    return this.currentWidth
  },

  get isLandscapePhone() {
    return this.currentWidth <= 920 && this.currentHeight <= 550
  }
})

let timeoutID = setTimeout(() => {}, 1000)

const handleResize = () => {
  windowSizeState.currentWidth = window.innerWidth
  windowSizeState.currentHeight = window.innerHeight
}

const debouncedHandleResize = () => {
  clearTimeout(timeoutID)
  timeoutID = setTimeout(handleResize, 250)
}

window.addEventListener('resize', debouncedHandleResize)

export const newWidthScale = (minWidth) => {
  if (windowSizeState.currentWidth < minWidth) {
    const diff = minWidth - windowSizeState.currentWidth
    return 1 - diff / minWidth
  } else {
    return 1
  }
}

export const newHeightScale = (minHeight) => {
  if (windowSizeState.currentHeight < minHeight) {
    const diff = minHeight - windowSizeState.currentHeight
    return 1 - diff / minHeight
  }
  return 1
}
